<template>
<div class="container">
    <div class="row d-flex">
        <div class="col-12 col-xl-10">
            <div class="content-fixed">
                <Button @click="$router.go(-1)" size="small" type="outline" color="grey" class="mb-3">
                    <ArrowDropdown :rotate="90" /> Voltar
                </Button>
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                        <h3 class="regular c-ndarkthree d-flex">
                            <span class="c-ndarkthree bold">Detalhes do sacado</span>
                            <span class="c-nmidfour mr-0-25rem ml-0-25rem">|</span>
                            <el-skeleton style="width: 300px; height: 30px;" animated rows="1" v-if="!isAbleRenderTitle">
                                <template slot="template">
                                    <el-skeleton-item variant="rect" style="width: 300px; height: 30px;" />
                                </template>
                            </el-skeleton>
                            <span v-else>{{ economicGroup.name | formatName }}</span>
                        </h3>
                    </div>
                    <div>
                        <el-dropdown trigger="click" :hide-on-click="false">
                            <Button type="secondary" size="small" :color="getPrimaryColor">Ações</Button>
                            <el-dropdown-menu slot="dropdown" class="py-2">
                                <ActionBtnItemsContainer :withoutBottomLine="false" v-if="isCashforce">
                                    <el-dropdown-item>
                                        <span 
                                            class="c-ndarkthree medium px-3 d-flex align-items-center" 
                                            @click="handleZipDownload(documentsList)"
                                        >
                                            <Download size="16" color="#A1A8B8" class="mr-2"/>Baixar todos documentos
                                        </span>
                                    </el-dropdown-item>
                                </ActionBtnItemsContainer> 
                                <ActionBtnItemsContainer :withoutBottomLine="true" v-if="isCashforce">
                                    <el-dropdown-item>
                                        <el-dropdown placement="left-start" :show-timeout="0" class="d-flex">
                                            <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                                <CompanyIcon size="16" color="#A1A8B8" class="mr-1" />Classificar cadastro
                                                <ArrowDropdown class="ml-5" color="#A1A8B8" rotate="270"/>
                                            </span>
                                            <el-dropdown-menu slot="dropdown" class="mt-n2">
                                                <el-dropdown-item>
                                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClassificationChange(economicGroup, false)" :style="isRejected ? null : 'pointer-events: none;'">
                                                        <CheckPayment size="18" color="#A1A8B8" :style="isRejected ? 'visibility: hidden;' : null" />
                                                        <span class="ml-1">Aprovar</span>
                                                    </span>
                                                </el-dropdown-item>
                                                <el-dropdown-item>
                                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClassificationChange(economicGroup, true)" :style="!isRejected ? null : 'pointer-events: none;'">
                                                        <CheckPayment size="18" color="#A1A8B8" :style="!isRejected ? 'visibility: hidden;' : null" />
                                                        <span class="ml-1">Reprovar</span>
                                                    </span>
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </el-dropdown-item>
                                </ActionBtnItemsContainer>
                                <ActionBtnItemsContainer :withoutBottomLine="isCashforce">
                                    <el-dropdown-item>
                                        <span
                                            class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                            @click="dialogs.creditLimit = true"
                                        >
                                            <Money size="16" color="#A1A8B8" class="mr-2"/>Definir limite de crédito
                                        </span>
                                    </el-dropdown-item>
                                </ActionBtnItemsContainer>
                                <ActionBtnItemsContainer 
                                    v-if="isAbleRenderProposalPerBuyer" 
                                    :withoutBottomLine="true"
                                >
                                    <el-dropdown-item>
                                        <span
                                            class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                            @click="goToBuyersRule"
                                        >
                                            <Buyers size="16" color="#A1A8B8" class="mr-2 svg-stroke"/>Propostas por sacado
                                        </span>
                                    </el-dropdown-item>
                                </ActionBtnItemsContainer>
                                <ActionBtnItemsContainer 
                                    v-if="isAbleToRenderProviderRules" 
                                    :withoutBottomLine="true"
                                >
                                    <el-dropdown-item>
                                        <span
                                            class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                            @click="goToProviders"
                                        >
                                            <Providers size="16" color="#A1A8B8" class="mr-2"/>Regras por cedente
                                        </span>
                                    </el-dropdown-item>
                                </ActionBtnItemsContainer>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-4 box-details">
            <h4 class="medium ndarkfour mb-3">Sobre o Sacado</h4>
            <AboutProfileBuyer class="col-12 col-xl-10" :info="economicGroup" />
        </div>
        <div 
            v-if="!isCashforce" 
            class="col-12 mt-4 box-details"
        >
            <h4 class="medium ndarkfour mb-3">Limite de crédito do sacado</h4>

            <CreditLimitAbout v-if="creditLimit && Object.keys(creditLimit).length > 0" class="col-12 col-xl-10" :creditLimit="creditLimit" />
            <el-skeleton :rows="1" animated v-else>
                <template slot="template">
                    <el-skeleton-item class="mt-1" variant="span" style="width: 976px; height: 138px;" />
                </template>
            </el-skeleton>
        </div>
        <div class="col-12 mt-4 box-details pt-2" v-if="providers.length">
            <h4 class="medium ndarkfour mb-3">Cedentes vinculados</h4>
            <TableContainer 
                :hasTable="!!providers.length"
                :isLoading="loading" 
                :pagination="pagination" 
                @updatePage="updatePage($event)"
                class="col-12 col-xl-10 p-0"
                skeletonClass="col-12 col-xl-10"
                :totalPerPage="10"
            >
                <EconomicGroupProvidersLinked
                    :providers="providers"
                    @classificationChange="handleClassificationChange($event)"
                    :showLimitAndActions="showLimitAndActions()"
                />
            </TableContainer>
        </div>
        <div class="col-12 col-xl-10 mt-4 box-details pt-2 px-0" v-if="isCashforce">
            <TableLoading v-if="loadingTable" :rows="10" rowHeight="89" class="mt-1" :tableHeader="false"/>
            <ListBuyerDocuments v-else :documentsList="documentsList" />
        </div>
        <div class="spacer" style="margin-bottom:150px;" />
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
    <CreditLimit 
        :dialogVisible="dialogs.creditLimit" 
        @closeModal="dialogs.creditLimit = false" 
        :selectedEconomicGroupId="economicGroup.id" 
    />
</div>
</template>

<script>
// Icons
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import CheckPayment from '@/components/icons/CheckPayment'
import CompanyIcon from '@/components/icons/Company'
import Download from '@/components/icons/Download'
import Money from '@/components/icons/Money'
import Buyers from '@/components/icons/Buyers'
import Providers from '@/components/icons/Assignor'

// Requests
import sendFilesToZip from '@/api/sendFilesToZip'
import updateRejectedEconomicGroup from '@/api/updateRejectedEconomicGroup'
import downloadArchive from '@/api/downloadArchive'
import getProvidersByGroupId from '@/api/getProvidersByGroupId'
import getEconomicGroupDocuments from '@/api/getEconomicGroupDocuments'
import getEconomicGroupCreditLimit from '@/api/getEconomicGroupCreditLimit'
import getEconomicGroupAbout from '@/api/getEconomicGroupAbout'

// Other Components
import AboutProfileBuyer from '@/components/about/AboutProfileBuyer'
import ListBuyerDocuments from '@/components/about/ListBuyerDocuments'
import FullLoading from '@/components/loading/FullLoading'
import TableLoading from '@/components/loading/TableLoading'
import TableContainer from '@/components/tables/TableContainer'
import EconomicGroupProvidersLinked from '@/components/tables/EconomicGroupProvidersLinked'
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer'
import CreditLimit from '@/components/modals/CreditLimit.vue'
import CreditLimitAbout from '@/components/about/CreditLimitAbout.vue'

// Constants
import { ACCESS_LEVEL } from '@/utils/constants'

export default {
    components: {
        ArrowDropdown,
        CheckPayment,
        CompanyIcon,
        Download,
        AboutProfileBuyer,
        ListBuyerDocuments,
        FullLoading,
        TableLoading,
        TableContainer,
        EconomicGroupProvidersLinked,
        ActionBtnItemsContainer,
        CreditLimit,
        Money,
        CreditLimitAbout,
        Buyers,
        Providers,
    },
    data() {
        return {
            economicGroup: {},
            documentsList: [],
            loadingTable: true,
            loading: false,
            providers: [],
            page: 1,
            pagination: {},
            dialogs: {
                creditLimit: false
            },
            creditLimit: {},
            ACCESS_LEVEL,
        }
    },
    computed: {
        isRejected() {
            if(this.economicGroup?.sponsors){
                const [sponsor] = this.economicGroup?.sponsors
            
                return sponsor?.economicGroupSponsor?.rejected
            }

            return false
        },
        isAbleRenderTitle(){
            return this.economicGroup?.name
        },
        isAbleRenderProposalPerBuyer(){
            return this.economicGroup?.economicGroupRule?.modelOffers != 'manual' 
                    && this.$store.state.user.accessLevel === ACCESS_LEVEL.ADMIN
                    && !this.isCashforce
        },
        isAbleToRenderProviderRules(){
            return this.economicGroup?.economicGroupRule?.modelOffers != 'manual'
                    && !this.isCashforce
        }
    },
    methods: {
        async getBuyersDocuments() {
            const groupWithDocuments = await getEconomicGroupDocuments(this.$route.params.economicGroupId)

            const filteredDocuments = groupWithDocuments.documents.filter((document) => document.docType != 0)

            this.documentsList = filteredDocuments

        },
        showLimitAndActions() {
            if (this.isCashforce) return false
            if (this.economicGroup?.economicGroupRule?.modelOffers != 'manual') return true
            if (this.economicGroup?.economicGroupRule?.modelOffers == 'manual') return false
        },
        async handleClassificationChange(economicGroup, reject) {
            const notificationText = reject ? 'reprovado' : 'aprovado'
            
            const result = await updateRejectedEconomicGroup({
                economicGroupId: economicGroup.id, 
                sponsorCnpjId: this.$store.state.user.cnpjId,
                rejected: reject
            })
            
            if (result.ok) {
                this.$notify({
                    title: `Sacado ${notificationText} com sucesso.`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
        },
        async handleZipDownload(files) {
            this.$store.commit('user/setIsDownloadLoading', true)

            const zipPath = await sendFilesToZip(files)
            await downloadArchive(`${process.env.VUE_APP_ROOT_API}/${zipPath}`)

            this.$store.commit('user/setIsDownloadLoading', false)
            setTimeout(() => {
                this.$notify({
                    title: 'Documentos baixados com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }, 500)
        },
        async getProvidersByGroupId(){
            this.loading = true

            const providers = await getProvidersByGroupId(this.$route.params.economicGroupId, { page: this.page })
            console.log(providers);
            this.providers = providers.rows
            this.pagination = providers.pagination

            this.loading = false

        },
        async updatePage(page){
            this.page = page
            await this.getProvidersByGroupId()
        },
        async getEconomicGroupCreditLimit() {
            const creditLimit = await getEconomicGroupCreditLimit(this.$route.params.economicGroupId)

            if(!creditLimit.totalCreditLimit){
                creditLimit.usedCreditLimit = 0
                creditLimit.availableCreditLimit = 0
            }

            this.creditLimit = creditLimit
        },
        goToBuyersRule() {
            this.$router.push(`/buyers/offerRules/${this.$route.params.economicGroupId}`)
        },
        goToProviders() {
            this.$router.push(`/buyers/providers/${this.$route.params.economicGroupId}`)
        },
    },
    async created() {
        this.loadingTable = true

        const [economicGroup] = await Promise.allSettled([
            getEconomicGroupAbout(this.$route.params.economicGroupId),
            this.getBuyersDocuments(),
            this.getEconomicGroupCreditLimit(),
            this.getProvidersByGroupId(),
        ])

        this.economicGroup = economicGroup?.value
        
        if (!this.economicGroup) this.$router.push('/404')

        this.loadingTable = false
    },
}
</script>

<style lang="scss">
    .without-line {
        border: 0px!important;
    }
</style>
